var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jiao-nang-zhu-zhuang-tu"},[_c('dv-border-box-11',{attrs:{"title":"需求信息统计","titleWidth":250}},[_c('div',{ref:"jiao_nang_zhu_zhuang_tu_echarts",staticStyle:{"width":"100%","height":"90%"},on:{"click":function($event){return _vm.$emit('click')}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }